import { useSelector } from "react-redux";
import Styles from "./Attendance.module.css";

export default function CalendarBox({
  month,
  year,
  goToNextMonth,
  goToPreviousMonth,
}) {
  const getMonthName = (monthIndex) => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return months[monthIndex];
  };

  const { loading, error, AttendanceRecs } = useSelector(
    (s) => s.AttendanceRecordsListReducer
  );

  const daysName = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sat"];
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const firstDayOfMonth = new Date(year, month, 1).getDay();
  const days = Array.from({ length: daysInMonth }, (_, index) => index + 1);
  const paddingDays = Array.from({ length: firstDayOfMonth }, () => null);
  const isPresentDay = days.map((ev) => {
    let yr = new Date(year, +month, ev + 1).toISOString().split("T")[0];

    for (let i = 0; i < AttendanceRecs?.length; i++) {
      const formattedUTC = new Date(AttendanceRecs[i]?.Attendance_Marked_date)
        .toISOString()
        .split("T")[0];
      if (new Date(yr).getTime() === new Date(formattedUTC).getTime()) {
        return { day: ev, Attendance: AttendanceRecs[i]?.Attendance_Marked };
      }
    }

    return { day: ev, Attendance: "" };
  });

  return window.innerWidth <= 481 ? (
    <>
      <div class="calendar-container">
        <div class="calendar-nav">
          <button class="nav-btn prev-btn" onClick={() => goToPreviousMonth()}>
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <polyline points="15,18 9,12 15,6" />
            </svg>
          </button>
          <h4 class="month-year">
            {getMonthName(month)} {year}
          </h4>
          <button class="nav-btn next-btn" onClick={() => goToNextMonth()}>
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <polyline points="9,18 15,12 9,6" />
            </svg>
          </button>
        </div>

        <div class="calendar-grid">
          <div class="calendar-header-row">
            {daysName.map((day, i) => (
              <div class="day-header" key={i + 890}>
                {day}
              </div>
            ))}
          </div>

          <div class="calendar-days">
            {paddingDays.map((_, index) => (
              <div
                key={`padding-${index}`}
                className={Styles.calendar_cell}
              ></div>
            ))}

            {isPresentDay.map((ev) => (
              <div
                key={ev?.day}
                className={
                  ev?.Attendance == 1
                    ? Styles.calendar_cell_present
                    : ev?.Attendance == 2
                    ? Styles.calendar_cell_absent
                    : Styles.calendar_cell
                }
                class={
                  ev?.Attendance == 1
                    ? "day present"
                    : ev?.Attendance == 2
                    ? "day absent"
                    : "day"
                }
              >
                {ev?.day}
              </div>
            ))}
            {/* <div class="day prev-month">31</div>
            <div class="day">1</div>
            <div class="day">2</div>
            <div class="day">3</div>
            <div class="day present">4</div>
            <div class="day present">5</div>
            <div class="day">6</div>
            <div class="day">7</div>
            <div class="day present">8</div>
            <div class="day">9</div>
            <div class="day">10</div>
            <div class="day">11</div>
            <div class="day">12</div>
            <div class="day present">13</div>
            <div class="day">14</div>
            <div class="day">15</div>
            <div class="day">16</div>
            <div class="day present">17</div>
            <div class="day">18</div>
            <div class="day">19</div>
            <div class="day">20</div>
            <div class="day present">21</div>
            <div class="day">22</div>
            <div class="day">23</div>
            <div class="day">24</div>
            <div class="day present">25</div>
            <div class="day present">26</div>
            <div class="day">27</div>
            <div class="day">28</div>
            <div class="day">29</div>
            <div class="day">30</div>
            <div class="day next-month">1</div> */}
          </div>
        </div>
      </div>
    </>
  ) : (
    <div className={Styles.calendar_box}>
      <div className={Styles.calendar_header}>
        <span>
          {getMonthName(month)} {year}
        </span>
      </div>
      <div className={Styles.calendar_body}>
        <div className={Styles.calendar_grid}>
          {daysName.map((day) => (
            <div key={day} className={Styles.calendar_cell}>
              {day}
            </div>
          ))}
        </div>
      </div>
      <div className={Styles.calendar_body}>
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            Loading...
          </div>
        ) : (
          <div className={Styles.calendar_grid}>
            {paddingDays.map((_, index) => (
              <div
                key={`padding-${index}`}
                className={Styles.calendar_cell}
              ></div>
            ))}

            {isPresentDay.map((ev) => (
              <div
                key={ev?.day}
                className={
                  ev?.Attendance == 1
                    ? Styles.calendar_cell_present
                    : ev?.Attendance == 2
                    ? Styles.calendar_cell_absent
                    : Styles.calendar_cell
                }
              >
                {ev?.day}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
